<template>
    <section class="assign-permission-page">
        <!-- 左侧：角色列表 -->
        <div class="panel roles-panel">
            <div class="panel-header">
                <div class="panel-title">
                    <i class="el-icon-user-solid panel-icon"></i>
                    <span>用户角色</span>
                </div>
                <el-button
                    @click="handleQuery"
                    size="small"
                    type="primary"
                    plain
                    icon="el-icon-refresh"
                    class="header-btn"
                >刷新</el-button>
            </div>
            <div class="panel-body">
                <div class="role-list">
                    <div
                        v-for="role in roles"
                        :key="role.Id"
                        @click="operate(role.Id)"
                        :class="['role-item', { active: role.Id === roleid }]"
                    >
                        <span class="role-dot"></span>
                        <span class="role-name">{{ role.Name }}</span>
                    </div>
                    <div v-if="roles.length === 0" class="role-empty">
                        <i class="el-icon-s-custom"></i>
                        <p>暂无角色数据</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- 右侧：权限菜单 -->
        <div class="panel perms-panel">
            <div class="panel-header">
                <div class="panel-title">
                    <i class="el-icon-s-check panel-icon"></i>
                    <span>对应权限菜单</span>
                    <el-tag v-if="currentRoleName" size="small" type="info" class="role-tag">{{ currentRoleName }}</el-tag>
                </div>
                <el-button
                    :loading="loadingSave"
                    @click="saveAssign"
                    size="small"
                    type="primary"
                    icon="el-icon-check"
                    class="header-btn save-btn"
                >{{ loadingSaveStr }}</el-button>
            </div>
            <div class="panel-body tree-body">
                <div class="block">
                    <el-tree
                        :data="data5"
                        show-checkbox
                        node-key="value"
                        ref="tree"
                        default-expand-all
                        :expand-on-click-node="true"
                        :check-strictly="true"
                    >
                        <span class="custom-tree-node" slot-scope="{ node, data }">
                            <span class="tree-label-wrap">
                                <i :class="getNodeIcon(data)" class="tree-node-icon"></i>
                                <span class="tree-label">{{ node.label }}</span>
                                <el-button
                                    @click.stop="reverse(data.btns)"
                                    v-if="data.btns && data.btns.length > 1"
                                    size="mini"
                                    type="text"
                                    class="reverse-btn"
                                >反选</el-button>
                            </span>
                            <span class="tree-actions">
                                <el-checkbox-group v-model="assignBtns">
                                    <el-checkbox
                                        v-for="btn in data.btns"
                                        :key="btn.value"
                                        :label="btn.value.toString()"
                                        class="perm-checkbox"
                                    >
                                        {{ btn.label }}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </span>
                        </span>
                    </el-tree>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import util from '../../../util/date'
    import {getRoleListPage, getPermissionTree, getPermissionIds, addRolePermission} from '../../api/api';

    let id = 1000;

    export default {
        data() {
            const data = [];
            return {
                roles: [],
                roleid: 0,
                data5: [],
                btns: [],
                assigns: [],
                checked1: false,
                loadingSaveStr:'保存',
                loadingSave:false,
                assignBtns: [],
                defaultProps: {
                    children: 'children',
                    label: 'label',
                    btns: 'btns',
                },
                selectedPermissions: [],
                currentRoleCode: "",
                stores: {
                    role: {
                        data: []
                    },
                    permissionTree: {
                        data: []
                    }
                },
                buttonProps: {
                    type: "default",
                    size: "small"
                },
                selectRole: {},
                menuData: [],
                menuSelections: [],
                menuLoading: false,
                authLoading: false,
                checkAll: false,
                currentRoleMenus: [],
            }
        },
        computed: {
            currentRoleName() {
                const role = this.roles.find(r => r.Id === this.roleid);
                return role ? role.Name : '';
            }
        },
        methods: {
            getNodeIcon(data) {
                if (data.children && data.children.length > 0) {
                    return 'el-icon-folder-opened';
                }
                if (data.btns && data.btns.length > 0) {
                    return 'el-icon-menu';
                }
                return 'el-icon-document';
            },
            //反选
            reverse(ls){
                console.log(this.data5);
                console.log(ls);
                if(ls && ls.length){
                    for(let i=0;i<ls.length;i++){
                        let btn = ls[i];
                        let findBtnIndex = this.assignBtns.findIndex(t=>t == btn.value);
                        if(findBtnIndex>-1){
                            this.assignBtns.splice(findBtnIndex,1);
                        }else{
                            this.assignBtns.push(""+btn.value);
                        }
                    }
                }
            },
            //性别显示转换
            formatEnabled: function (row, column) {
                return row.Enabled ? '正常' : '未知';
            },
            formatCreateTime: function (row, column) {
                return (!row.CreateTime || row.CreateTime == '') ? '' : util.formatDate.format(new Date(row.CreateTime), 'yyyy-MM-dd');
            },
            //获取角色列表
            handleQuery() {
                getRoleListPage().then((res) => {
                    this.roles = res.data.response.data;
                    this.getPermissions();
                });
            },
            //获取菜单树
            getPermissions() {
                let _this=this;
                let para = {needbtn: false}
                getPermissionTree(para).then((res) => {
                    _this.loadingSave=false;
                    _this.loadingSaveStr='保存';
                    this.data = res.data.response.children;
                    this.data5 = JSON.parse(JSON.stringify(this.data));
                });
            },
            //获取菜单Id，通过角色id
            getPermissionIds(rid) {
                let _this=this;
                this.assigns = [];
                this.assignBtns = [];
                let para = {rid: rid}
                getPermissionIds(para).then((res) => {
                    _this.loadingSave=false;
                    _this.loadingSaveStr='保存';
                    this.$refs.tree.setCheckedKeys(res.data.response.permissionids);
                    this.assignBtns = res.data.response.assignbtns;
                });
            },
            operate(id) {
                this.loadingSave=true;
                this.loadingSaveStr='加载中...';
                this.roleid = id;
                this.getPermissionIds(id);
            },
            saveAssign() {
                let _this=this;
                this.loadingSave=true;
                this.loadingSaveStr='保存中...';
                let pids = this.$refs.tree.getCheckedKeys();
                try {
                    if (this.assignBtns.length > 0) {
                        let btns = this.assignBtns;
                        console.log(btns)
                        for (let i = 0; i < this.assignBtns.length; i++) {
                            let assginbtn = this.assignBtns[i];
                            if (assginbtn && assginbtn > 0) {
                                pids.push(assginbtn);
                            }
                        }
                    }
                } catch (e) {
                    this.$message({
                        message: "操作异常",
                        type: "error",
                    });
                    return false;
                }
                console.log(this.assignBtns);
                console.log(pids);

                let para = {pids: pids, rid: this.roleid}
                if (para.rid > 0) {
                    addRolePermission(para).then((res) => {
                        _this.loadingSave=false;
                        _this.loadingSaveStr='保存';

                        if (res.data.success) {
                            this.$message({
                                message: res.data.msg,
                                type: 'success'
                            });

                            let para = {rid: this.roleid}
                            getPermissionIds(para).then((res) => {
                                this.$refs.tree.setCheckedKeys(res.data.response.permissionids);
                                this.assignBtns = res.data.response.assignbtns;
                                this.$message({
                                    message: "数据更新成功",
                                    type: 'success'
                                });
                            });
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type: 'error'
                            });
                        }
                    });
                } else {
                    this.loadingSaveStr='保存';
                    this.loadingSave=false;
                    this.$message({
                        message: "你请选要操作的角色",
                        type: 'error'
                    });
                }
            },
            append(data) {
                const newChild = {id: id++, label: 'testtest', children: []};
                if (!data.children) {
                    this.$set(data, 'children', []);
                }
                data.children.push(newChild);
            },

            remove(node, data) {
                const parent = node.parent;
                const children = parent.data.children || parent.data;
                const index = children.findIndex(d => d.id === data.id);
                children.splice(index, 1);
            },
            // 获取数据
            findTreeData: function () {
                this.menuLoading = true
                this.$api.menu.findMenuTree().then((res) => {
                    this.menuData = res.data
                    this.menuLoading = false
                })
            },
            // 角色选择改变监听
            handleRoleSelectChange(val) {
                if(val == null || val.val == null) {
                    return
                }
                this.selectRole = val.val
                this.$api.role.findRoleMenus({'roleId':val.val.id}).then((res) => {
                    this.currentRoleMenus = res.data
                    this.$refs.menuTree.setCheckedNodes(res.data)
                })
            },
            // 树节点选择监听
            handleMenuCheckChange(data, check, subCheck) {
                if(check) {
                    // 节点选中时同步选中父节点
                    let parentId = data.parentId
                    this.$refs.menuTree.setChecked(parentId, true, false)
                } else {
                    // 节点取消选中时同步取消选中子节点
                    if(data.children != null) {
                        data.children.forEach(element => {
                            this.$refs.menuTree.setChecked(element.id, false, false)
                        });
                    }
                }
            },
            // 递归全选
            checkAllMenu(menuData, allMenus) {
                menuData.forEach(menu => {
                    allMenus.push(menu)
                    if(menu.children) {
                        this.checkAllMenu(menu.children, allMenus)
                    }
                });
            },
            // 角色菜单授权提交
            submitAuthForm() {
                let roleId = this.selectRole.id
                if('admin' == this.selectRole.name) {
                    this.$message({message: '超级管理员拥有所有菜单权限，不允许修改！', type: 'error'})
                    return
                }
                this.authLoading = true
                let checkedNodes = this.$refs.menuTree.getCheckedNodes(false, true)
                let roleMenus = []
                for(let i=0, len=checkedNodes.length; i<len; i++) {
                    let roleMenu = { roleId:roleId, menuId:checkedNodes[i].id }
                    roleMenus.push(roleMenu)
                }
                this.$api.role.saveRoleMenus(roleMenus).then((res) => {
                    if(res.code == 200) {
                        this.$message({ message: '操作成功', type: 'success' })
                    } else {
                        this.$message({message: '操作失败, ' + res.msg, type: 'error'})
                    }
                    this.authLoading = false
                })
            },
            renderContent(h, { node, data, store }) {
                return (
                    <div class="column-container">
                    <span style="text-algin:center;margin-right:80px;">{data.label}</span>
                <span style="text-algin:center;margin-right:80px;">
                    <el-tag type={data.isbtn ?'success':'info'} size="small">
                {!data.isbtn ?'菜单':'按钮'}
            </el-tag>
                </span>

                </div>);
            },
            // 时间格式化
            dateFormat: function (row, column, cellValue, index){
                return format(row[column.property])
            }
        },
        mounted() {
            this.loadingSave=true;
            this.loadingSaveStr='加载中...';
            this.handleQuery();
        }
    }
</script>

<style scoped>
/* ========== 页面基础 ========== */
.assign-permission-page {
    display: flex;
    gap: 12px;
    padding: 12px;
    height: calc(100vh - 110px);
    min-height: 500px;
    box-sizing: border-box;
}

/* ========== 通用面板 ========== */
.panel {
    display: flex;
    flex-direction: column;
    background: var(--content-az-bg, #fff);
    border: var(--content-az-border, 1px solid #f0f0f0);
    border-radius: 12px;
    box-shadow: var(--content-az-shadow, 0 4px 20px rgba(2, 132, 199, 0.08));
    overflow: hidden;
    transition: all 0.3s ease;
}

.roles-panel {
    width: 320px;
    min-width: 260px;
    flex-shrink: 0;
}

.perms-panel {
    flex: 1;
    min-width: 500px;
}

.panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid rgba(128, 128, 128, 0.15);
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.06) 0%, rgba(64, 158, 255, 0.02) 100%);
}

.panel-title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    font-weight: 600;
    color: var(--body-color, #303133);
}

.panel-icon {
    font-size: 18px;
    color: #409eff;
}

.role-tag {
    margin-left: 8px;
    font-weight: normal;
}

.header-btn {
    border-radius: 6px;
}

.save-btn {
    background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
    border-color: transparent;
    color: #fff;
}
.save-btn:hover {
    background: linear-gradient(135deg, #3a8ee6 0%, #5cadff 100%);
    color: #fff;
}

.panel-body {
    flex: 1;
    padding: 16px;
    overflow: auto;
}

.tree-body {
    padding: 12px 20px;
}

/* ========== 左侧角色列表 ========== */
.role-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.role-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.25s ease;
    border: 1px solid transparent;
    background: transparent;
}

.role-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #c0c4cc;
    transition: all 0.25s ease;
    flex-shrink: 0;
}

.role-name {
    font-size: 14px;
    color: var(--body-color, #606266);
    transition: color 0.25s ease;
}

.role-item:hover {
    background: rgba(64, 158, 255, 0.08);
    border-color: rgba(64, 158, 255, 0.2);
    transform: translateX(2px);
}

.role-item:hover .role-dot {
    background: #409eff;
}

.role-item:hover .role-name {
    color: #409eff;
}

.role-item.active {
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.12) 0%, rgba(64, 158, 255, 0.06) 100%);
    border-color: rgba(64, 158, 255, 0.35);
}

.role-item.active .role-dot {
    background: #409eff;
    box-shadow: 0 0 8px rgba(64, 158, 255, 0.5);
}

.role-item.active .role-name {
    color: #409eff;
    font-weight: 600;
}

.role-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px 20px;
    color: #909399;
    gap: 12px;
}

.role-empty i {
    font-size: 48px;
    opacity: 0.4;
}

.role-empty p {
    margin: 0;
    font-size: 14px;
}

/* ========== 右侧权限树 ========== */
.block {
    height: 100%;
}

.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px 16px;
    font-size: 14px;
    padding: 10px 0;
    min-height: 44px;
}

.tree-label-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.tree-node-icon {
    font-size: 16px;
    color: #409eff;
    opacity: 0.85;
}

.tree-label {
    font-weight: 500;
    color: var(--body-color, #303133);
}

.reverse-btn {
    margin-left: 4px;
    padding: 2px 8px;
    font-size: 12px;
    color: #909399;
}

.reverse-btn:hover {
    color: #409eff;
}

.tree-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 12px;
    margin-left: auto;
}

.perm-checkbox {
    margin-right: 0 !important;
    padding: 4px 8px;
    border-radius: 6px;
    transition: background 0.2s ease;
}

.perm-checkbox:hover {
    background: rgba(64, 158, 255, 0.06);
}

/* 树节点行高自适应 */
.assign-permission-page >>> .el-tree-node__content {
    height: auto !important;
    min-height: 44px;
    align-items: center;
    padding-top: 2px;
    padding-bottom: 2px;
    border-radius: 8px;
    transition: background 0.2s ease;
}

.assign-permission-page >>> .el-tree-node__content:hover {
    background: rgba(64, 158, 255, 0.06);
}

/* ========== Dark 主题适配 ========== */
body[data-theme="dark"] .panel-icon {
    color: #22d3ee;
}

body[data-theme="dark"] .role-item:hover {
    background: rgba(34, 211, 238, 0.08);
    border-color: rgba(34, 211, 238, 0.2);
}

body[data-theme="dark"] .role-item:hover .role-dot,
body[data-theme="dark"] .role-item.active .role-dot {
    background: #22d3ee;
    box-shadow: 0 0 8px rgba(34, 211, 238, 0.55);
}

body[data-theme="dark"] .role-item:hover .role-name,
body[data-theme="dark"] .role-item.active .role-name {
    color: #22d3ee;
}

body[data-theme="dark"] .role-item.active {
    background: linear-gradient(135deg, rgba(34, 211, 238, 0.12) 0%, rgba(34, 211, 238, 0.05) 100%);
    border-color: rgba(34, 211, 238, 0.35);
}

body[data-theme="dark"] .tree-node-icon {
    color: #22d3ee;
    opacity: 0.9;
}

body[data-theme="dark"] .reverse-btn:hover {
    color: #22d3ee;
}

body[data-theme="dark"] .perm-checkbox:hover {
    background: rgba(34, 211, 238, 0.08);
}

body[data-theme="dark"] .save-btn {
    background: linear-gradient(135deg, #0ea5e9 0%, #06b6d4 100%);
    box-shadow: 0 4px 14px rgba(6, 182, 212, 0.35);
}

body[data-theme="dark"] .save-btn:hover {
    background: linear-gradient(135deg, #0284c7 0%, #0891b2 100%);
    box-shadow: 0 6px 18px rgba(6, 182, 212, 0.45);
}

body[data-theme="dark"] .assign-permission-page >>> .el-tree-node__content:hover {
    background: rgba(34, 211, 238, 0.08);
}

/* ========== 响应式 ========== */
@media (max-width: 992px) {
    .assign-permission-page {
        flex-direction: column;
        height: auto;
    }
    .roles-panel {
        width: 100%;
        min-width: auto;
        max-height: 320px;
    }
    .perms-panel {
        min-width: auto;
        min-height: 400px;
    }
}
</style>
